import React, { useContext, useEffect, useState } from "react";
import Navbar from "../../../components/user/navbar/Navbar";
import Footer from "../../../components/user/footer/Footer";

import { Container, Row } from "react-bootstrap";
import SimpleBanner from "../../../components/user/general/SimpleBanner";
import AppContext from "../../../context/AppContext";
import axios from "axios";
import TpDealCard from "../../../components/user/card/dealCard/TpDealCard";
import MarqueeBanner from "../../../components/user/Marqueebanner/Marqueebanner";

const WishlistPage = () => {
  const [wishlistDeals, setWishlistDeals] = useState([]);
  const { baseUrl } = useContext(AppContext);

  const getWishlistDeals = () => {
    const savedCustomer = JSON.parse(localStorage.getItem("loggedInUser"));

    const formData = new FormData();
    formData.append("tpcustomer_id", savedCustomer?.id);

    axios
      .post(`${baseUrl}/customer/wishlist/viewWishlist`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log("Wishlist response:", response.data);
        setWishlistDeals(response.data.wishlist || []);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getWishlistDeals();
  }, []);

  return (
    <>
      <MarqueeBanner />
      <Navbar />
      <SimpleBanner
        title="Wishlist Page"
        subtitle="Because the Best Things Deserve to Wait."
        breadcrumbs={[
          { label: "Home", href: "/" },
          { label: "Wishlist", href: "/wishlist" },
        ]}
      />

      <Container fluid className="trending-deals-container px-4">
        <Row className="mt-3 mb-3">
          {wishlistDeals.length === 0 ? (
            <p className="text-center mt-4">Your wishlist is empty.</p>
          ) : (
            wishlistDeals.map((item) => {
              const deal = item.tpdeal ?? item; // fallback agar tpdeal na ho
              return (
                <TpDealCard
                  key={deal.id ?? item.id}
                  deal={deal}
                  screenName="wishlist"
                  onRemove={() => {
                    setWishlistDeals((prev) =>
                      prev.filter((wishlistItem) => {
                        const wishlistDeal =
                          wishlistItem.tpdeal ?? wishlistItem;

                        return wishlistDeal.id !== deal.id;
                      }),
                    );
                  }}
                />
              );
            })
          )}
        </Row>
      </Container>

      <Footer />
    </>
  );
};

export default WishlistPage;
